function ModalCard({ cast }) {
  return (
    <>
      <div className="w-8/12 mt-4 h-full bg-white rounded-lg border border-gray-200 shadow-md dark:bg-gray-800 dark:border-gray-700 flex flex-col">
        <div className="h-1/2">
          <img className="rounded-t-lg max-h-60" src={cast.profilePict} />
        </div>
        <div className="pt-3 h-1/2">
          <p className="mb-1 text-md text-gray-700 dark:text-gray-400">
            {cast.name}
          </p>
        </div>
      </div>
    </>
  );
}

export default ModalCard;
